import { render } from "./BotTab.vue?vue&type=template&id=4100ab6a&scoped=true"
import script from "./BotTab.vue?vue&type=script&lang=js"
export * from "./BotTab.vue?vue&type=script&lang=js"

import "./BotTab.vue?vue&type=style&index=0&id=4100ab6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4100ab6a"]])

export default __exports__